import React, { useEffect, useRef, useState } from 'react';

const easeOut = (t) => 1 - Math.pow(1 - t, 3);

export const CountUp = ({ value = 0, format = (n) => Math.round(n).toLocaleString(), duration = 900, className }) => {
  const [display, setDisplay] = useState(0);
  const ref = useRef({ raf: 0, start: 0 });
  const prev = useRef(0);

  useEffect(() => {
    const target = Number(value) || 0;
    const from = prev.current;
    prev.current = target;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setDisplay(target); return;
    }
    ref.current.start = 0;
    const tick = (ts) => {
      if (!ref.current.start) ref.current.start = ts;
      const p = Math.min(1, (ts - ref.current.start) / duration);
      setDisplay(from + (target - from) * easeOut(p));
      if (p < 1) ref.current.raf = requestAnimationFrame(tick);
    };
    ref.current.raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(ref.current.raf);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, duration]);

  return <span className={className}>{format(display)}</span>;
};
